module.exports = __webpack_public_path__ + "media/images/vp/parallax.new.05.c-0e9a5a1d438011dfcffaad12a5f905f5.svg";